export default __webpack_public_path__ + "static/media/complementary--trucks--g3.41659ea2.png";